import { Component, OnInit, input, inject } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FormControlService } from "@app/shared/services/form-control.service";
import { FormBase } from "@app/shared/models/form-base.model";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "@app/shared/dialog/confirm-dialog/confirm-dialog.component";
import { DynamicFormFieldComponent } from "@app/shared/components/dynamic-form-control/dynamic-form-control.component";

@Component({
    selector: "inspekt-dynamic-form",
    templateUrl: "./dynamic-form.component.html",
    styles: [":host { display: block; width: 100%; }"] ,
    providers: [FormControlService],
    imports: [ReactiveFormsModule, DynamicFormFieldComponent],
})
export class DynamicFormComponent implements OnInit {
    private matDialog = inject(MatDialog);

    readonly fields = input<FormBase<any>[]>([]);
    readonly form = input<FormGroup>(undefined);

    ngOnInit() {
        this.fields().sort((a, b) => a.order - b.order);
    }

    receiveEmitValue($event: any) {
        if ($event.deleteField) {
            delete this.form().value[$event.deleteField];
            return;
        }

        if ($event.oldField.key && $event.newField.key) {
            const isDuplicateKey =
                $event.oldField.key !== $event.newField.key &&
                this.form().value.hasOwnProperty($event.newField.key);

            if (isDuplicateKey) {
                this.fields()[$event.index].key = $event.oldField.key;
                this.fields()[$event.index].value = $event.oldField.value;
                const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
                    disableClose: false,
                    autoFocus: true,
                    hasBackdrop: true,
                });
                dialogRef.componentInstance.dialog = {
                    title: "Invalid picklist",
                    content: "Has duplicate picklist value",
                    showCancelButton: false,
                };

                return;
            }

            delete this.form().value[$event.oldField.key];
            this.form().value[$event.newField.key] = $event.newField.value;
        }
    }
}
